import React from 'react';
import type { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import { css } from '@emotion/react';
import { legacyOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import ControlledRadioButtons from 'components/common/form-controlled/controlled-radio-buttons';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import type { VcsModalFormValues } from './access-card/use-connection-modal-access-card-form.hook';

export type BlockRadioButtonProps = {
  options: Array<CheckboxOptionType | string | number>;
  form: UseFormReturnType<VcsModalFormValues>;
};

export const VcsConnectionModalFormAuthenticationTypeButton = ({ options, form }: BlockRadioButtonProps) => (
  <Container>
    <ControlledRadioButtons
      label={{ id: 'templates.add.new.field.authorize.type' }}
      name={'authenticationType'}
      form={form}
      block
      options={options}
      optionType={'button'}
      buttonStyle={'solid'}
    />
  </Container>
);

// New design has no checked override here: the segmented styling (lime fill on the selected segment,
// dark text, lime frame and dividers) now lives in the RadioButtons wrapper itself, matching Figma
// node 2092:11719. Only the legacy checked look stays call-site-local.
const Container = styled.div`
  ${legacyOnly(
    theme => css`
      && .ant-radio-button-wrapper-checked {
        border: 1px solid ${theme.vcsPickerSelected};
        color: ${theme.vcsPickerSelected};
        background-color: white;
      }
    `
  )}
`;
